module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/sub-saharan_africa-df5c7dd528eae50272fd2bf474f31445.png";